import { defineStore } from 'pinia';
import {getUserRides} from "@/services/tripService";

export const useRideStore = defineStore('ride', {
    state: () => ({
        user: null, // Stores user information
        loading: false, // Tracks the loading state
        error: null, // Stores error messages
    }),
    actions: {
        // get rides to user
        async userrides(status = '', page = 1, limit = 10) {
            this.loading = true;
            this.error = null;

            try {
                const rides = await getUserRides(status, page, limit);
                return rides;
            } catch (error) {
                console.error('Error fetching user rides information:', error);
                this.error = 'Failed to fetch user rides information';
                throw error;
            } finally {
                this.loading = false;
            }
        }
    },
    getters: {
        /**
         * Check if user is logged in
         */
        isLoggedIn: (state) => !!state.user,
    },
});
